import { DashboardLayout } from "admin/components/layout/components/DashboardLayout";
import { Navbar } from "admin/components/layout/components/Navbar";
import { ContextTipsTable } from "../components/ContextTipsTable";
import { hasPermission } from "utils/hasPermission";
import { useGetUserInfo } from "hooks/useGetUserInfo";

export const AdminContextTips = () => {
  const { userInfo } = useGetUserInfo();
  const canView = ["View Context Tips", "Manage Context Tips"].some((p) =>
    hasPermission(userInfo, p),
  );

  return (
    <DashboardLayout>
      <Navbar
        title="Context Tips"
        description="Manage contextual tip cards shown across the product"
      />
      <div className="mt-4">
        {canView ? (
          <ContextTipsTable />
        ) : (
          <p className="text-gray-600">
            You do not have permission to view context tips.
          </p>
        )}
      </div>
    </DashboardLayout>
  );
};
